import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'
import buttonRed from '../assets/button-red.webp'
import iconBSand from '../assets/icon-b-sand.webp'

const serviceStyles = [
  {
    key: 'col1',
    bg: 'bg-lachs',
    textColor: 'text-white',
    itemColor: 'text-white/80',
    linkColor: 'text-white hover:text-sand',
  },
  {
    key: 'col2',
    bg: 'bg-haut',
    textColor: 'text-white',
    itemColor: 'text-white/80',
    linkColor: 'text-white hover:text-sand',
  },
  {
    key: 'col3',
    bg: 'bg-espresso',
    textColor: 'text-sand',
    itemColor: 'text-sand/80',
    linkColor: 'text-sand hover:text-white',
  },
]

export default function Services() {
  const { t } = useTranslation()

  return (
    <section id="services" className="bg-white relative">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="text-center pt-24 pb-16 px-6 relative"
      >
        <p className="font-body text-rot text-xs tracking-widest uppercase mb-3">
          {t('services.kicker')}
        </p>
        <h2 className="font-headline text-espresso text-4xl md:text-5xl mb-6">
          {t('services.h2')}
        </h2>
        <p className="font-body text-espresso/60 text-base leading-relaxed max-w-2xl mx-auto">
          {t('services.intro')}
        </p>
        {/* Rotating Button */}
        <img
          src={buttonRed}
          alt="good design and text for you from buenas"
          loading="lazy"
          width={1182}
          height={1182}
          className="absolute -top-8 right-[6%] md:right-[10%] w-32 sm:w-36 md:w-48 animate-spin-slow pointer-events-none"
        />
      </motion.div>

      {/* 3-Column Grid */}
      <div className="max-w-7xl mx-auto px-6 pb-20 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {serviceStyles.map((style, index) => {
          const items = t(`services.${style.key}.items`, { returnObjects: true }) as string[]
          return (
            <motion.div
              key={style.key}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className={`${style.bg} rounded-3xl p-8 transition-[transform,box-shadow] duration-300 hover:scale-[1.02] hover:shadow-xl`}
            >
              <img
                src={iconBSand}
                alt="buenas studio icon"
                loading="lazy"
                width={1138}
                height={1773}
                className="w-10 mb-6"
              />
              <h3 className={`font-headline text-2xl mb-6 ${style.textColor}`}>
                {t(`services.${style.key}.title`)}
              </h3>
              <ul className="space-y-1">
                {items.map((item, i) => (
                  <li key={i} className={`font-body text-sm leading-loose ${style.itemColor}`}>
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          )
        })}
      </div>

      {/* Dark Panel */}
      <div className="bg-espresso py-10 text-center px-6">
        <p className="font-body text-sand/60 text-sm tracking-wide leading-relaxed">
          {t('services.panel')}
        </p>
      </div>
    </section>
  )
}
